import {  getAdmin, putAdmin } from "../axios/api/AdminBaseUrl"

export const settings ={
    list:{
        key:"list",
        call: () => {
            return getAdmin(`/admin/escalation-rules/`)
          }
    },
    update:{
      key: "update",
      call:(id, payload)=>{ return putAdmin(`/admin/escalation-rules/${id}/`,payload);
    }
  },
}
